import { useState } from 'react'
import { ZonesCategorySliderWrapper } from './styles'
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react'
import 'swiper/css'
import ZonesSliderButton from './components/ZonesSliderButton'
import { useResolutions } from 'store/resolutions'

interface ZonesModalCategoryProps {
    images: string[]
    alt: string
}

const ZonesCategorySlider = ({ images, alt }: ZonesModalCategoryProps) => {
    const { isMobile, isTablet } = useResolutions()

    const [isPrevNavVisible, setIsPrevNavVisible] = useState<boolean>(false)
    const [isNextNavVisible, setIsNextNavVisible] = useState<boolean>(!isTablet)

    const handleIndexChange = (swiper: SwiperClass) => {
        const activeSlideIndex = swiper.activeIndex

        if (activeSlideIndex === 0) {
            setIsPrevNavVisible(false)
            return
        }
        if (activeSlideIndex === images.length - 1) {
            setIsNextNavVisible(false)
            return
        }
        !isPrevNavVisible && setIsPrevNavVisible(true)
        !isNextNavVisible && setIsNextNavVisible(true)
    }

    return (
        <ZonesCategorySliderWrapper direction="row">
            <Swiper
                spaceBetween={isMobile ? 12 : 8}
                slidesPerView={'auto'}
                onRealIndexChange={isTablet ? undefined : handleIndexChange}
            >
                <div slot="container-start">
                    {isPrevNavVisible && <ZonesSliderButton direction="prev" />}
                </div>
                {images.map((imageUrl, index) => (
                    <SwiperSlide key={index}>
                        <img src={imageUrl} alt={alt} loading="lazy" />
                    </SwiperSlide>
                ))}
                <div slot="container-end">
                    {isNextNavVisible && <ZonesSliderButton direction="next" />}
                </div>
            </Swiper>
        </ZonesCategorySliderWrapper>
    )
}

export default ZonesCategorySlider
